module.exports = __webpack_public_path__ + "img/mixed-roof.4a94c8e1.png";